import React, { useState } from 'react';
import { FC } from 'types';
import { useTranslation } from 'react-i18next';

import CreatePostCallToAction from 'components/CreatePostCallToAction';
import PostList from 'components/PostList';
import { getLayout } from 'components/Layouts/MainLayout';
import SpaceEmptyState from 'components/SpaceEmptyState/SpaceEmptyState';
import CommunityHeader from 'components/CommunityHeader/CommunityHeader';

interface SpacePageProps {
  postListState: {
    useCacheFirst: boolean;
  };
}

const SpacePage: FC<SpacePageProps> = ({ postListState }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [spaceName, setSpaceName] = useState('');

  return (
    <>
      <CommunityHeader
        pageTitle={t('pages-space_title', 'Space {{name}}', {
          name: spaceName,
        })}
      />
      <CreatePostCallToAction
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        setSpaceName={setSpaceName}
      />
      <PostList
        customEmptyState={
          <SpaceEmptyState onClick={() => setIsModalOpen(true)} />
        }
        emptyMessage={t(
          'pages-spaces-post_list_empty_message',
          'Start a discussion by creating a new post from above.'
        )}
        emptyTitle={t("Looks like you'll be the first!")}
        sharedState={postListState}
        t={t}
      />
    </>
  );
};

SpacePage.getLayout = getLayout;

export default SpacePage;
